import * as React from 'react';

import { useSelectedTeamQuery } from '~teacher/components/Account/hooks';
import { useAccount } from '~teacher/hook/account';
import { useTeamsMembers } from '~teacher/hook/team';

import { TeamMembersTable, TeamMembersTableHeader } from './TeamMembersTable';

export function TeamMembers() {
  const accountQuery = useAccount();
  const selectedTeamQuery = useSelectedTeamQuery();

  const teamMembersQuery = useTeamsMembers({
    teamId: selectedTeamQuery.data?.id,
  });

  if (
    teamMembersQuery.isLoading &&
    selectedTeamQuery.isLoading &&
    accountQuery.isLoading
  ) {
    return <AccountSubscriptionTeamMembersLoading />;
  }

  if (
    teamMembersQuery.isError ||
    selectedTeamQuery.isError ||
    accountQuery.isError
  ) {
    return <AccountSubscriptionTeamMembersError />;
  }

  if (!teamMembersQuery.data) {
    return <AccountSubscriptionTeamMembersNoData />;
  }

  const canInvite = selectedTeamQuery.data?.permissions.canInvite;

  return (
    <React.Fragment key={selectedTeamQuery.data?.id}>
      <TeamMembersTableHeader canInvite={canInvite} />
      <TeamMembersTable />
    </React.Fragment>
  );
}

function AccountSubscriptionTeamMembersLoading() {
  return (
    <>
      <TeamMembersTableHeader />
      <div className="grid col-span-2">Loading</div>;
    </>
  );
}

function AccountSubscriptionTeamMembersError() {
  return (
    <>
      <TeamMembersTableHeader />
      <div className="grid col-span-2">Error</div>
    </>
  );
}

function AccountSubscriptionTeamMembersNoData() {
  return (
    <>
      <TeamMembersTableHeader />
      <div className="grid col-span-2">No team members</div>
    </>
  );
}
